var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"label text-white m-r-xs none-radius inline",class:_vm.statusClass},[_vm._v(" "+_vm._s(_vm.translatedStatus)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }